namespace Rfm {
    const KeyupRegex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    const KeySpecials = ["Enter", "Backspace", "Control", "Delete"];
    let KeyupTimer;
    const operationSecondTimeoutMs = 1000; // 1 second

    const annoAttuale = new Date().getFullYear();
    const dataIniziale = new Date(annoAttuale - 1, 0);
    const dataFinale = new Date();

    export namespace Clienti {
        let FiltroClientiRfm: FiltroRfm;
        let Opzioni: BaseFiltriOptions;
        let InfiniteScrollTable: any;
        export let IsTabInitialized: boolean = false;
        export const NomeEventoTrigger = "rfm:click.fascia";

        export function InitTabIndici(baseUrlFiltro: string, divTabella: string, bodyTabella: string, rigaTabella: string, loadStatusClass: string, initRowPerPage: number, ricercaTabdataAttr: string) {
            $(Controlli.Utility.BodyName).off(NomeEventoTrigger);

            Opzioni = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass };
            FiltroClientiRfm = CreaFiltro(initRowPerPage);
            IsTabInitialized = true;
            InfiniteScrollTable = SetupInfiniteScrollAndSearch(Opzioni, FiltroClientiRfm, ricercaTabdataAttr);
        }
    }

    function CreaFiltro(righePerPagina: number): FiltroRfm {
        return {
            PaginaAttuale: 1,
            PagineTotali: 2,
            RighePerPagina: righePerPagina,
            GenericId: 0,
            RicercaTestuale: '',
            DataFine: dataFinale.toDateString(),
            DataInizio: dataIniziale.toDateString(),
            FasciaSelezionata: null
        };
    }
    function SetupInfiniteScrollAndSearch(opzioni: BaseFiltriOptions, filtro: FiltroRfm, searchInputSelector: string) {
        let lastPageTriggered = false;
        let infiniteScrollTable: JQuery<HTMLElement> = Controlli.UtilityTabella.InitInfiniteScrollPost(opzioni.bodyTabella, opzioni.baseUrlFiltro, opzioni.rigaTabella, opzioni.divTabella, opzioni.loadStatusClass, filtro);

        let infScroll = infiniteScrollTable.data('infiniteScroll');
        infiniteScrollTable.on('load.infiniteScroll', function (event, body, path, response) {
            filtro.PaginaAttuale = infScroll.pageIndex;
        });
        infiniteScrollTable.on('append.infiniteScroll', function (event, body, path, items: NodeList, response) {
            if (items.length > 0) {
                Controlli.Utility.DestroyControl(opzioni.bodyTabella);
                Controlli.Utility.RefreshControl(opzioni.bodyTabella);
            }
        });

        infiniteScrollTable.on('last.infiniteScroll', function () {
            lastPageTriggered = true;
        });

        $(searchInputSelector).on("keyup", function (e) {
            const searchTerm = $(this).val() as string;

            if (searchTerm !== filtro.RicercaTestuale && (searchTerm === '' || KeyupRegex.test(searchTerm) || KeySpecials.includes(e.key))) {
                filtro.RicercaTestuale = searchTerm;
                clearTimeout(KeyupTimer);
                KeyupTimer = setTimeout(() => ReloadTable(opzioni, infiniteScrollTable, lastPageTriggered, filtro), operationSecondTimeoutMs);
            }
        });

        $(Controlli.Utility.BodyName).on("rfm:click.fascia", function (e, idFascia) {
            if (filtro.FasciaSelezionata == idFascia) {
                filtro.FasciaSelezionata = null;
            } else {
                filtro.FasciaSelezionata = idFascia;
            }
            ReloadTable(opzioni, infiniteScrollTable, lastPageTriggered, filtro);
        });

        return infiniteScrollTable
    }
    function ReloadTable(opzioni: BaseFiltriOptions, infiniteScrollTable: any, lastPageTriggered: boolean, filtro: FiltroRfm) {
        $(opzioni.divTabella).scrollTop(0);
        $(opzioni.bodyTabella).fadeOut(200, "swing", function () {
            filtro.PaginaAttuale = 1;
            filtro.PagineTotali = 2;

            $(opzioni.bodyTabella).html(Controlli.Ajax.AjaxPostHTML(opzioni.baseUrlFiltro, filtro));
            Controlli.Utility.DestroyControl(opzioni.bodyTabella);
            Controlli.Utility.RefreshControl(opzioni.bodyTabella);

            if (lastPageTriggered) {
                infiniteScrollTable.infiniteScroll('destroy');
                infiniteScrollTable = Controlli.UtilityTabella.InitInfiniteScrollPost(opzioni.bodyTabella, opzioni.baseUrlFiltro, opzioni.rigaTabella, opzioni.divTabella, opzioni.loadStatusClass, filtro, false);
            }

            filtro.PaginaAttuale++;
        });
        $(opzioni.bodyTabella).fadeIn(200);
    }

    interface BaseFiltriOptions {
        divTabella: string;
        bodyTabella: string;
        baseUrlFiltro: string;
        rigaTabella: string;
        loadStatusClass: string;
    }

    export class FiltroRfm extends Controlli.UtilityTabella.BaseFiltriListaDto {
        FasciaSelezionata: number | null;
    }
}